import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';

const routes: RouteRecordRaw[] = [
	{
		path: '/connexion',
		name: ROUTES.LOGIN,
		component: () => import('./views/Login.vue'),
	},
	{
		path: '/logas',
		name: ROUTES.LOGAS,
		component: () => import('./views/Logas.vue'),
	},
	{
		path: '/password-forgotten',
		name: ROUTES.FORGOTPASSWORD,
		component: () => import('./views/ForgotPassword.vue'),
	},
	{
		path: '/nouveau-mot-de-passe',
		name: ROUTES.RESETPASSWORD,
		component: () => import('./views/ResetPassword.vue'),
	},
	{
		path: '/reset-password',
		redirect: { name: ROUTES.RESETPASSWORD },
	},
	{
		path: '/invitation/:token',
		name: ROUTES.INVITATION,
		component: () => import('./views/Register.vue'),
	},
];

export default routes;
